import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";
import axiosProvisioningCognito from "../utils/marquetCognito";

import { cognitoUri } from "../../constants/defaultValues";

import {
  getCustomer
} from "../../utils/helpers";

import {
  notification
} from "../actions";

export const verifyOtpCognito = createAsyncThunk("verifyOtpCognito", async (payload, thunkAPI) => {
  try {
    const response = await axiosProvisioningCognito.post(`${cognitoUri}/verify-otp`, payload);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `The OTP was not verify`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const activateTenantAccount = createAsyncThunk("activateTenantAccount", async (payload, thunkAPI) => {
  try {
    const response = await axiosProvisioningCognito.post(`${cognitoUri}/activate-account`, payload);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({ title: `The account is active`, message: `${response.data.message}`, type: `success` }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `The account was not activated`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const sendNewOtp = createAsyncThunk("sendNewOtp", async (payload, thunkAPI) => {
  try {
    const response = await axiosProvisioningCognito.post(`${cognitoUri}/resend-otp`, payload);
    if (response && response.data && response.data.success) {
      thunkAPI.dispatch(notification({ title: `The OTP has been sent`, message: `${response.data.message}`, type: `success` }));
      return response.data
    } else {
      thunkAPI.dispatch(notification({ title: `The OTP was not sent`, message: `${response.data.message}`, type: `warning` }));
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})